import { TOGGLE_SIDEBAR, OPEN_MENU, CHANGE_DIRECTION, LOAD_PAGE, CLOSE_MENU } from '../constants/auroraUiConstants';

const initialState = {
  direction: localStorage.getItem('lang') === 'ar' ? 'rtl' : 'ltr',
  sidebarOpen: false,
  pageLoaded: true,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarOpen: !state.sidebarOpen,
      };
    case OPEN_MENU:
      return {
        ...state,
        sidebarOpen: true,
      };
    case CLOSE_MENU:
      return {
        ...state,
        sidebarOpen: false,
      };
    case CHANGE_DIRECTION:
      return {
        ...state,
        direction: action.direction,
      };
    case LOAD_PAGE:
      return {
        ...state,
        pageLoaded: action.isLoaded,
      };
    default:
      return state;
  }
}
